/**
 * Recipe picker string constants — RENAME-READY (Phase 3, R1).
 *
 * All new user-facing selection-surface strings route through here so the
 * Carl-gated noun flip ("Template" → "Recipe") is a single small commit.
 * Until Carl confirms the naming window, these say "Template".
 */

export const PICKER_STRINGS = {
  title: "Choose a Template",
  subtitle: "What each template produces, at a glance.",
  recommended: "RECOMMENDED",
  recentlyUsed: "RECENTLY USED",
  browseAll: "Browse all templates",
  use: "Use",
  useThisTemplate: "Use This Template",
  newTemplate: "New Template",
  floorConflict: "Floor conflict",
  yours: "YOURS",
  // When Carl's naming window closes, flip these to "Recipe" variants:
  // title: "Choose a Recipe",
  // subtitle: "What each recipe produces, at a glance.",
  // etc.
} as const;
